import { FC, useState } from 'react';

import { ModalBody } from '@bonusly/design-system';

import { useGlobalSearch } from '../../queries/search';
import { SearchContext } from './context';
import { SearchBody } from './SearchBody';
import { SearchFooter } from './SearchFooter';
import { SearchHeader } from './SearchHeader';
import { selectSearchResult } from './utils';

interface SearchContentProps {
	onClose: VoidFunction;
}

export const SearchContent: FC<SearchContentProps> = ({ onClose }) => {
	const [inputValue, setInputValue] = useState('');

	const { data, isFetching } = useGlobalSearch(inputValue, {
		keepPreviousData: true,
	});

	return (
		<SearchContext.Provider
			value={{
				bonuses: data?.bonuses || [],
				isFetching,
				query: inputValue,
				users: data?.users || [],
				...selectSearchResult(data),
			}}
		>
			<SearchHeader onChange={setInputValue} onClose={onClose} value={inputValue} />
			<ModalBody px={3} py={0}>
				<SearchBody />
			</ModalBody>
			<SearchFooter />
		</SearchContext.Provider>
	);
};
